import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import ChallengeBundleCoachingUpsell from './ChallengeBundleCoachingUpsell';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const ChallengeBundleCoachingUpsellPage = () => (
  <Elements stripe={stripePromise}>
    <ChallengeBundleCoachingUpsell />
  </Elements>
);

export default ChallengeBundleCoachingUpsellPage;
